import type { ForwardedRef, RefCallback } from 'react';

type MergeableRef<T> = ForwardedRef<T> | RefCallback<T> | undefined;

/**
 * Applies one node to several refs. Needed wherever a forwarded ref has to
 * coexist with a ref a library owns — Maskito's `useMaskito()` attaches its
 * input listeners through a ref callback of its own.
 * @see https://maskito.dev/frameworks/react#merge--maskito-ref-with-the-third-party-ref
 */
export const mergeRefs =
  <T>(...refs: MergeableRef<T>[]): RefCallback<T> =>
  (node) => {
    refs.forEach((ref) => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(node);
        return;
      }

      ref.current = node;
    });
  };
